import { HttpHeaders } from '@angular/common/http';

import { PlatformEndpointService } from './shared/services/communicator/endpoint/endpoint.service';
import { CopyService } from './shared/services/copies/copy.service';
import { ParametersService } from './shared/services/parameters/parameters.service';
import { MockService, PlatformCommunicatorService } from './shared/shared.module';

/**
 * Inicialización de la función loadResources, carga los recursos necesarios de la aplicación
 *
 * *Set loadResources interface, loads the necessary resources of the application*
 *
 * @access public
 * @type {function}
 */
export function loadResources(
  mockService: MockService,
  endpointService: PlatformEndpointService,
  parametersService: ParametersService,
  copyService: CopyService,
  platformCommunicatorService: PlatformCommunicatorService,
) {
  return async () => {

    await configAPIResources(endpointService, mockService);

    await loadApplicationsParametersAndRules(parametersService, platformCommunicatorService);

    await copyService.loadCopies();
  };
}

/**
 * Función asincrona que configura los recursos de la aplicación
 *
 * *Async function that configures app's API resources*
 *
 * @access public
 * @type {function}
 */
async function configAPIResources(endpointService: PlatformEndpointService, mockService: MockService) {
  await endpointService.loadURLS();
  await endpointService.loadMICRO();
  mockService.setMocks();
}

function paramedtrizedHeaders(
  headersParametrized: any,
  platformCommunicatorService: PlatformCommunicatorService,
) {

  let headers = new HttpHeaders({});

  Object.entries(headersParametrized).forEach(key => {
    headers = headers.append(key[0], key[1] as string);
  });

  platformCommunicatorService.setParametrizedHeaders(headers);
}

/**
 * Carga toda la configuración de la aplicación. Carga los parámetros de configuración
 * de la aplicación y las reglas de negocio.
 *
 * @access public
 * @type {function}
 * @param parametersService Servicio encargado de manejar la configuración de la aplicación
 * @param platformCommunicatorService Servicio encargado de manejar la comunicación con el Backend.
 */
async function loadApplicationsParametersAndRules(
  parametersService: ParametersService,
  platformCommunicatorService: PlatformCommunicatorService,
) {
  await parametersService.loadApplicationParameters();
  await parametersService.loadBusinessRules();
  // await parametersService.loadApplicationSettings();
  await parametersService.loadBiocatchContext();
  paramedtrizedHeaders(parametersService.getParameter('headers'), platformCommunicatorService);
}
